export default __webpack_public_path__ + "static/media/no-races.c0d77b97.png";